import { client } from '@/client';
import { Course } from '@/client/courses';

export const attemptLog = async (
  course: Course | null | undefined,
  attemptId: string | undefined,
  message: string,
): Promise<void> => {
  if (!course?.id || !attemptId) {
    return;
  }

  try {
    await client.learnerCourses.attemptLog(message, attemptId);
  } catch (e) {
    // Silently fail - debug logging should not break the app
  }
};
